console.log('开始读取 teaconfig.txt');


export const tryFallbackPaths = () => {
    return new Promise((reslove) => {
        // #ifdef APP
        const candidatePaths = [
            // 外部应用专属目录（通常文件会在 files/ 下）
            'file:///storage/emulated/0/Android/data/com.xingshengyz.billiardcashier/files/teaconfig.txt',

        ];

        const tryNext = (index) => {
            if (index >= candidatePaths.length) {
                console.error('未找到 teaconfig.txt，请确认文件位置与权限');
                return;
            }
            const url = candidatePaths[index];
            plus.io.resolveLocalFileSystemURL(url, function(entry) {
                entry.file(function(file) {
                    const reader = new plus.io.FileReader();
                    reader.readAsText(file, 'utf-8');
                    reader.onloadend = function(evt) {
                        console.warn('read success: ' + evt.target.result);
                        reslove(evt.target.result)
                    };
                    reader.onerror = function(err) {
                        console.error('读取文件内容失败:', JSON.stringify(err));
                        reslove('')
                    };
                }, function(err) {
                    console.warn('entry.file 失败: code=' + err.code + ' 路径: ' + url);
                    // tryNext(index + 1);
                    reslove('')
                });
            }, function(err) {
                reslove('')
                console.warn('路径不可用: ' + url + ' code=' + err.code);
                // tryNext(index + 1);
            });
        };
        tryNext(0);
        // #endif
        // #ifndef APP
        reslove('')
        // #endif
    })
}